module.exports = __webpack_public_path__ + "img/catering_menu_9.21edc35f.jpg";